/* ═══════════════════════════════════════
   MODEEQ GEMS — THEME JS
═══════════════════════════════════════ */

// ── PRODUCT SLIDESHOW ──────────────────
let currentSlide = 0;

function slideTo(index) {
  const slides = document.querySelectorAll('.slide');
  const dots = document.querySelectorAll('.slide-dot');
  const thumbs = document.querySelectorAll('.slide-thumb');
  if (!slides.length) return;

  // pause all videos
  slides.forEach(s => {
    const v = s.querySelector('video');
    if (v) v.pause();
  });

  slides[currentSlide]?.classList.remove('active');
  dots[currentSlide]?.classList.remove('active');
  thumbs[currentSlide]?.classList.remove('active');

  currentSlide = (index + slides.length) % slides.length;

  slides[currentSlide]?.classList.add('active');
  dots[currentSlide]?.classList.add('active');
  thumbs[currentSlide]?.classList.add('active');

  // autoplay video when it becomes active
  const activeVid = slides[currentSlide]?.querySelector('video');
  if (activeVid) { activeVid.play(); }
}

function slideMove(dir) {
  slideTo(currentSlide + dir);
}

// swipe support
(function() {
  let startX = 0;
  document.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
  document.addEventListener('touchend', e => {
    const diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50 && document.querySelector('.product-slideshow')) {
      slideMove(diff > 0 ? 1 : -1);
    }
  });
})();

// ── STICKY HEADER ──────────────────────
const header = document.querySelector('.site-header');
if (header) {
  window.addEventListener('scroll', () => {
    header.classList.toggle('scrolled', window.scrollY > 60);
  });
}

// ── MOBILE MENU ────────────────────────
function openMobileMenu() {
  document.getElementById('mobile-nav')?.classList.add('open');
}
function closeMobileMenu() {
  document.getElementById('mobile-nav')?.classList.remove('open');
}

// ── CART DRAWER ────────────────────────
function openCart() {
  document.getElementById('cart-drawer')?.classList.add('open');
  document.getElementById('cart-overlay')?.classList.add('open');
  document.body.style.overflow = 'hidden';
  fetchCart();
}
function closeCart() {
  document.getElementById('cart-drawer')?.classList.remove('open');
  document.getElementById('cart-overlay')?.classList.remove('open');
  document.body.style.overflow = '';
}
document.getElementById('cart-overlay')?.addEventListener('click', closeCart);

function fetchCart() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => renderCartDrawer(cart))
    .catch(err => console.error('Cart fetch error:', err));
}

function renderCartDrawer(cart) {
  const body = document.getElementById('cart-drawer-body');
  const subtotal = document.getElementById('cart-subtotal-price');
  const countEls = document.querySelectorAll('.cart-count');

  if (!body) return;

  countEls.forEach(el => {
    el.textContent = cart.item_count;
    el.style.display = cart.item_count > 0 ? 'flex' : 'none';
  });

  if (subtotal) {
    subtotal.textContent = formatMoney(cart.total_price);
  }

  if (cart.item_count === 0) {
    body.innerHTML = '<p class="cart-empty-msg">Your cart is empty.</p>';
    return;
  }

  body.innerHTML = cart.items.map(item => `
    <div class="cart-item">
      <img class="cart-item-img" src="${item.image}" alt="${item.title}">
      <div class="cart-item-info">
        <div class="cart-item-title">${item.product_title}</div>
        ${item.variant_title !== 'Default Title' ? `<div style="font-size:11px;color:var(--muted);margin-top:2px;">${item.variant_title}</div>` : ''}
        <div class="cart-item-price">${formatMoney(item.final_line_price)} <span style="font-size:10px;color:var(--muted)">×${item.quantity}</span></div>
        <div class="cart-item-remove" onclick="removeFromCart('${item.key}')">Remove</div>
      </div>
    </div>
  `).join('');
}

function removeFromCart(key) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  }).then(r => r.json()).then(cart => renderCartDrawer(cart));
}

function addToCart(variantId, quantity = 1) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity })
  })
  .then(r => r.json())
  .then(() => {
    fetchCart();
    openCart();
  })
  .catch(err => console.error('Add to cart error:', err));
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

// ── ADD TO CART BUTTONS ────────────────
document.addEventListener('click', e => {
  const btn = e.target.closest('[data-add-to-cart]');
  if (btn) {
    e.preventDefault();
    const variantId = btn.dataset.variantId;
    if (variantId) {
      btn.textContent = 'Adding...';
      btn.disabled = true;
      addToCart(variantId).then(() => {
        btn.textContent = 'Added!';
        setTimeout(() => {
          btn.textContent = btn.dataset.originalText || 'Add to Cart';
          btn.disabled = false;
        }, 2000);
      });
    }
  }
});

// ── PRODUCT PAGE - THUMBNAILS ──────────
document.querySelectorAll('.product-thumb').forEach((thumb, i) => {
  thumb.addEventListener('click', () => {
    const main = document.querySelector('.product-media-main');
    if (!main) return;
    const mainImg = main.querySelector('img');
    const mainVid = main.querySelector('video');
    const thumbImg = thumb.querySelector('img');
    const thumbVid = thumb.querySelector('video');
    document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
    if (thumbVid) {
      if (mainImg) mainImg.style.display = 'none';
      if (mainVid) { mainVid.src = thumbVid.src; mainVid.style.display = 'block'; }
    } else if (thumbImg) {
      if (mainVid) mainVid.style.display = 'none';
      if (mainImg) { mainImg.src = thumbImg.src; mainImg.style.display = 'block'; }
    }
  });
});

// ── PRODUCT PAGE - VARIANT SELECTOR ───
const variantSelect = document.querySelector('.variant-select');
if (variantSelect) {
  variantSelect.addEventListener('change', () => {
    const price = variantSelect.selectedOptions[0]?.dataset.price;
    const priceEl = document.querySelector('.product-page-price-val');
    if (price && priceEl) priceEl.textContent = formatMoney(parseInt(price));
    const addBtn = document.querySelector('.add-to-cart-btn[data-add-to-cart]');
    if (addBtn) addBtn.dataset.variantId = variantSelect.value;
  });
}

// ── CART PAGE QTY ──────────────────────
document.querySelectorAll('.qty-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const input = btn.closest('.qty-wrap')?.querySelector('.qty-input');
    if (!input) return;
    const key = btn.closest('[data-line-key]')?.dataset.lineKey;
    let val = parseInt(input.value) || 1;
    val = btn.dataset.action === 'plus' ? val + 1 : Math.max(0, val - 1);
    input.value = val;
    if (key) updateCartLine(key, val);
  });
});

function updateCartLine(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  }).then(r => r.json()).then(() => location.reload());
}

// ── GEM CATEGORY SELECTOR ──────────────
// Populated by Liquid in the section
window.selectCat = function(el, url) {
  document.querySelectorAll('.cat-card').forEach(c => c.classList.remove('active'));
  el.classList.add('active');
  const panel = document.getElementById('cat-products-panel');
  const labelEl = document.getElementById('cat-products-label');
  const rowEl = document.getElementById('cat-product-row');
  if (!panel || !rowEl) return;

  const cat = el.dataset.cat;
  const data = window.catData && window.catData[cat];
  if (!data) return;

  if (labelEl) labelEl.textContent = 'Showing: ' + data.label;
  rowEl.innerHTML = data.products.map(p => `
    <a href="${p.url}" class="mini-card">
      <div class="mini-gem">
        ${p.image ? `<img src="${p.image}" alt="${p.title}" loading="lazy">` : ''}
      </div>
      <div class="mini-info">
        <div class="mini-name">${p.title}</div>
        <div class="mini-price">${p.price}</div>
        <div class="mini-wt">${p.meta}</div>
      </div>
    </a>
  `).join('') + `
    <a href="${data.url}" class="cat-view-all">
      <div class="cat-view-all-num">${data.count}</div>
      <div class="cat-view-all-label">Items Available</div>
      <span class="btn-primary" style="margin-top:12px;font-size:10px;padding:10px 24px;">View All</span>
    </a>
  `;

  panel.style.display = 'block';
};

// init first cat
document.addEventListener('DOMContentLoaded', () => {
  const firstCat = document.querySelector('.cat-card');
  if (firstCat) firstCat.click();
  fetchCart();
});

// ── VIDEO SIZE FIX ─────────────────────
document.querySelectorAll('.product__media video, .product-media video, .media video').forEach(v => {
  v.style.maxWidth = '100%';
  v.style.maxHeight = '600px';
  v.style.objectFit = 'contain';
});
// ── LIGHTBOX ──────────────────────────
document.addEventListener('click', function(e) {
  const img = e.target.closest('.product-slideshow .slide.active img');
  const vid = e.target.closest('.product-slideshow .slide.active video');
  const media = img || vid;
  if (!media) return;

  const overlay = document.createElement('div');
  overlay.className = 'lightbox-overlay';

  let el;
  if (vid) {
    el = document.createElement('video');
    el.src = vid.currentSrc || vid.src;
    el.autoplay = true;
    el.controls = true;
    el.loop = true;
    el.muted = false;
    el.style.cursor = 'default';
  } else {
    el = document.createElement('img');
    el.src = img.src;
  }

  const close = document.createElement('div');
  close.className = 'lightbox-close';
  close.innerHTML = '✕';

  const hint = document.createElement('div');
  hint.className = 'lightbox-hint';
  hint.textContent = 'Click anywhere to close';

  overlay.appendChild(el);
  overlay.appendChild(close);
  overlay.appendChild(hint);
  document.body.appendChild(overlay);
  document.body.style.overflow = 'hidden';

  function closeLightbox() {
    if (vid) el.pause();
    overlay.remove();
    document.body.style.overflow = '';
  }

  overlay.addEventListener('click', function(e) {
    if (e.target === overlay || e.target === close) closeLightbox();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeLightbox();
  }, { once: true });
});
